import { create } from "zustand";

import type { User } from "@/models";
import { authService } from "@/services/auth";

export interface AuthState {
    user: User | null;
    loading: boolean;
    hasLoaded: boolean;
    loadMe: () => Promise<void>;
    logout: () => Promise<void>;
    setUser: (u: User | null) => void;
}

export const useAuthStore = create<AuthState>((set) => ({
    user: null,
    loading: false,
    hasLoaded: false,
    setUser: (u) => set({ user: u }),
    loadMe: async () => {
        set({ loading: true });
        try {
            const user = await authService.me();
            set({ user });
        } finally {
            set({ loading: false, hasLoaded: true });
        }
    },
    logout: async () => {
        try {
            await authService.logout();
        } catch (error) {
            // If the server says we're not authenticated, treat as already logged out.
            if ((error as any)?.response?.status !== 401) throw error;
        } finally {
            set({ user: null, hasLoaded: true });
        }
    },
}));
